import { render, staticRenderFns } from "./Group_Admin.vue?vue&type=template&id=b679b22c"
import script from "./Group_Admin.vue?vue&type=script&lang=js"
export * from "./Group_Admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports